import { useMemo } from "react"

import { DateTime } from "@bounce/date"

import type { Review } from "@/utils/reviews"

export const useWeeklyReview = (reviews: Review[]) => {
  return useMemo(() => {
    const today = DateTime.now()
    const isMonday = today.weekday === 1

    // If Monday, start from previous week, otherwise current week
    let startOfWeek = isMonday ? today.minus({ weeks: 1 }).startOf("week") : today.startOf("week")

    const endOfWeek = startOfWeek.plus({ days: 6 }).endOf("day")

    return reviews.filter(review => {
      const reviewDate = DateTime.fromISO(review.completedAt)
      return reviewDate >= startOfWeek && reviewDate <= endOfWeek
    })
  }, [reviews])
}
